import React from 'react';

export default function Promotions() {
  return <h2>Benvenuto nella pagina Promozioni</h2>;
}